(() => {
	angular.module('main').directive('addContract', addContract);

	addContract.$inject = [
		'templateRequestsService',
		'messageService',
		'fileUploadService',
		'emailService'
	];

	function addContract(
		templateRequestsService,
		messageService,
		fileUploadService,
		emailService
	) {
		return {
			restrict: 'E',
			scope: {
				chosenContract: '=',
				contracts: '=',
				email: '=',
				emailTemplates: '=',
				editContract: '&',
				fromSettings: '=',
				onChange: '&',
				tickTask: '='
			},
			template: `
                      <div>
                        <div class="field-info" ng-hide="tickTask">
                            <h4>Choose contract template</h4>
                            <div class="flex-row flex-wrap-xs">

                                <div class="select-style flex-grow-1 flex-with-full">

                                    <select ng-model="chosenContract" ng-disabled="button_disable" required
                                            ng-change = "onChange()"
                                            ng-options="contract as contract.name for contract in contracts | orderBy">
                                        <option value="" class="hide">Choose an existing contract template</option>
                                    </select>
                                </div>

                                <btn-edit ng-disabled="!chosenContract.name || chosenContract.signed" type="button" class="btn-edit-md hidden-xs"
                                          ng-if="!fromSettings"
                                          sn-text="Edit contract"
                                          ng-click="editContract({contract:chosenContract})"></btn-edit>
                                <btn-edit ng-disabled="!chosenContract.name || chosenContract.signed" type="button" class="btn-edit-sm visible-xs"
                                          ng-if="!fromSettings"
                                          sn-text="Edit contract"
                                          ng-click="editContract({contract:chosenContract})"></btn-edit>

                            </div>
                        </div>

                        <div class="field-info">
                            <h4>Choose email template</h4>
                            <div class="flex-row">
                                <div class="select-style flex-grow-1">
                                    <select ng-model="email"
                                            ng-init="email = email || {}"
                                            ng-disabled="button_disable"
                                            ng-change="getEmailTemplate(email)"
                                            ng-options="template as template.name for template in emailTemplates | orderBy track by template.name">
                                    </select>
                                </div>
                            </div>
                        </div>

                      <div class="subject-row mt-20" ng-if="!fromSettings">
                        <insert-variable class="insert-variable" [variable-list-type]="'JOB_MENU_SUBJECT'" (on-variable-choose)="addSubjectVariable($event, 'subject-send-contract-automation')"></insert-variable>
                            <div class="field-info">
                                <h4>Subject</h4>
                                <div class="flex-row">
                                    <input id="subject-send-contract-automation" ng-disabled="button_disable" type="text" class="form-control"
                                           placeholder="Your online contract is ready" maxlength="255"
                                           ng-model="email.subject" required>
                                </div>
                            </div>
                      </div>

                            <div class="field-info" ng-if="!fromSettings">
                                <h4>Message</h4>
																<sn-quill-editor-web
																	[init-value]="email.text"
																	[toolbar-settings]="'variables attachments color size font'"
																	[files-obj]="email.attachmentsData"
																	[vars-list]="'JOB_MENU'"
																	[editor-i-d]="'wf_contract_email'"
																	(on-text-change)="email.text = $event">
                        				</sn-quill-editor-web>
                            </div>


                        <hr ng-if="!tickTask" class="mt-30 mb-30">

                    </div>
                `,
			replace: true,
			transclude: true,
			link(scope) {
				const emptyAttachmentsData = {
					attachments: [],
					filesSize: 0
				};

				function clearAttachments() {
					scope.email.attachmentsData = angular.copy(emptyAttachmentsData);
				}

				const isUserEmail = email =>
					!email.hasOwnProperty('emailTemplateType') &&
					!email.hasOwnProperty('defaultEmailTemplate');

				scope.$watchCollection(
					'email.attachmentsData',
					(newValue, oldValue) => {
						if (
							newValue &&
							newValue !== oldValue &&
							newValue.attachments.length &&
							newValue.attachments.length !== 0 &&
							scope.isUserEmail
						) {
							addUploadedAttachments(newValue);
						}
					}
				);

				function addUploadedAttachments(attachmentsData) {
					const { attachments } = attachmentsData;

					scope.uploadedAttachments = [];
					angular.forEach(attachments, attachment => {
						if (!attachment.id) {
							scope.uploadedAttachments.push(attachment);
						} else if (attachment.hasOwnProperty('checked')) {
							const copiedAttachment = angular.copy(attachment);
							scope.uploadedAttachments.push(copiedAttachment);
						}
					});
				}

				const setEmailTemplate = data => {
					scope.email = angular.copy(data);
					if (data.storedAttachments.length) {
						scope.email.attachmentsData = {
							attachments: fileUploadService.convertAttachmentsToShow(
								data.storedAttachments
							)
						};
						scope.$evalAsync();
					} else {
						clearAttachments();
					}
				};

				const showErrorMessage = () => {
					messageService.showToaster('e_0', 'general');
				};

				scope.addSubjectVariable = function($event, id) {
					const el = document.getElementById(id);
					scope.email.subject = emailService.addSubjectVariable(el, $event);
				};

				scope.getEmailTemplate = email => {
					if (scope.fromSettings) {
						return;
					}

					if (email === null) {
						scope.email = {
							text: '',
							attachmentsData: angular.copy(emptyAttachmentsData)
						};
					} else if (email && typeof email === 'object') {
						const isUserEmailChosen = isUserEmail(email);
						scope.isUserEmail = isUserEmail(email);
						if (isUserEmailChosen) {
							scope.email = email;

							if (
								(email.storedAttachments && email.storedAttachments.length) ||
								(scope.uploadedAttachments && scope.uploadedAttachments.length)
							) {
								const storedAttachments = angular.copy(email.storedAttachments);
								const allAttachments =
									storedAttachments !== null
										? angular.copy(email.storedAttachments)
										: [];

								if (
									scope.uploadedAttachments &&
									scope.uploadedAttachments.length
								) {
									angular.forEach(scope.uploadedAttachments, attachment => {
										allAttachments.push(attachment);
									});
								}
								scope.email.attachmentsData = {
									attachments: allAttachments
								};
							} else {
								clearAttachments();
							}
						} else if (email.id) {
							templateRequestsService
								.getTemplates('full_template', email.id)
								.subscribe(
									data => setEmailTemplate(data),
									error => showErrorMessage()
								);
						}
					} else {
						console.error('no chosen email');
					}
				};

				scope.disableDragDrop = function() {
					return true;
				};

				scope.uploadedAttachments = [];
				const email = scope.email;
				const isUserEmailChosen = isUserEmail(email);
				if (isUserEmailChosen) {
					scope.isUserEmail = true;
				} else if (email && typeof email === 'object' && email.id) {
					scope.getEmailTemplate(scope.email);
				} else {
					console.error('no scope.email.id');
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/Modals/addContract.js